import React from 'react';
import {
  Modal, ModalBody, ModalFooter
} from 'reactstrap';
import Select from '../forms/Select';
import {WithTranslation, withTranslation} from 'react-i18next';
import {MultiColumnsSelectItemModel} from '../forms/TwoColumnsSelect';
import {MultiSelect} from '../forms/MultiSelect';

interface SelectModalProps extends WithTranslation {
  options: { value: string; label: string}[];
  selectedOptions: { value: string; label: string}[];
  selectLabel: string;
  title: string;
  warningTitle?: string;
  warningText?: string;
  onSave: (selectedValues: any) => void;
  toggle: () => void;
  isOpen: boolean;
  isMultiSelect?: boolean;
  showJumbotron?: boolean;
  disableSelectClear?: boolean;
  optionName: string;
}

interface SelectModalState {
  selectedOptions: { value: string; label: string }[];
  multiSelectItems: MultiColumnsSelectItemModel[];
}

class SelectModal extends React.PureComponent<SelectModalProps, SelectModalState> {

  readonly state = {
    selectedOptions: [] as { value: string; label: string}[],
    multiSelectItems: [] as MultiColumnsSelectItemModel[]
  };

  componentDidUpdate(prevProps: SelectModalProps) {
    if (this.props.isOpen && prevProps !== this.props) {

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedOptions: this.props.selectedOptions,
      });
    }
    if (this.props != prevProps && this.props.isMultiSelect) {
      this.setState({
        multiSelectItems: this.props.options.map((o, inx) => {
          return {
            ...o,
            name: o.label,
            id: inx
          };
        })
      });
    }
  }

  getSelectedItemValues(selectedOptions: { value: string; label: string }[]) {
    return selectedOptions.map((v) => {
      return this.state.multiSelectItems.find((itm) => itm.value === v.value)!.id.toString();
    });
  }

  handleItemValueChange(items: MultiColumnsSelectItemModel[]) {
    const selectedItemValues: string[] = items.map((itm) => itm.value as string);
    this.setState({
      selectedOptions: this.props.options.filter((o) => selectedItemValues.includes(o.value))
    });
  }

  render() {
    const { t } = this.props;

    return (
      <Modal style={{ minWidth: '960px' }} backdrop={'static'} isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalBody>
          <div>
            <h1>{this.props.title}</h1>
            { this.props.showJumbotron && (
              <div className="modal-warning-jumbotron mt-2">
                <label>{this.props.warningTitle}</label>
                <p>{this.props.warningText}</p>
              </div>
            )}
            <div className="d-flex row info-container align-items-start ml-1 mt-2">
              <div className=" text-light mr-1">{this.props.selectLabel} </div>
              {
                !!this.props.isMultiSelect ?
                    <div>
                      <MultiSelect
                          itemValues={this.state.multiSelectItems}
                          defaultSelectedIds={this.getSelectedItemValues(this.state.selectedOptions)}
                          selectedAttributeName="id"
                          sortAttributeName="name"
                          handleValueChange={(val: any) => this.handleItemValueChange(val)}
                          filterAttributes={[ 'name' ]}
                          secondaryAtr="name"
                      />
                    </div>
                  :
                    <Select
                        value={this.state.selectedOptions}
                        className="mr-1"
                        placeholder={`Choose ${this.props.optionName}`}
                        options={this.props.options}
                        closeMenuOnSelect={!this.props.isMultiSelect}
                        isMulti={this.props.isMultiSelect}
                        hideSelectedOptions={false}
                        disableClear={!!this.props.disableSelectClear}
                        label="option"
                        onChange={(value: any) => {
                          this.setState({ selectedOptions: value });
                        }}
                    />
              }
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <button type="button" className="btn btn-outline-secondary mr-1" onClick={this.props.toggle}>{t('b.cancel_Generic cancel button translation').toUpperCase()}</button>
            <button type="button" className="btn btn-primary" onClick={() => this.props.onSave(this.state.selectedOptions)}>{t('b.save_Generic save button translation').toUpperCase()}</button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(SelectModal);
